
$(".key-more").click(function(e){
    
	var obj=$(this).prev("ul");
	if(obj.hasClass("cur"))
	{
		obj.removeClass("cur");
		$(this).find("font").text("↓");
	}
	else{
		obj.addClass("cur");
		$(this).find("font").text("↑");
	}
    
    
});


$(".bh-tc").change(function(){
	var id=$(this).data("id");
	var i=$(this).find("option:selected").attr("money");
	$(".price1_"+id).find("span").text(i);
    var j=$(this).find("option:selected").attr("money");
    $(".price2_"+id).find(".transcy-money").text(j);
});


//--手机
$(".faiter").click(function(){
	$(".srb-box,.wap-tool-close").addClass("open");
	$(".wap-tool>.faiter").addClass("show-cur");
});


$(".wap-tool-close").click(function(){
	$(".srb-box,.wap-tool-close").removeClass("open");
	$(".wap-tool>.faiter").removeClass("show-cur");
});

$(".t-xs").click(function(){
	
	$(".sr-bh-list .a-item").click(function(){
		if($(".product-collection").width() <750)
		{
			var gurl_s=$(this).data("href");
			location.href=gurl_s;
		}
		
	});
});

//-------切换单位

function change_togm(i)
{
	var tocm=30.48;
	var toinch=0.0328084;//上面是长度
	
	var tokg=0.4536;
	var tolb=2.2046;
	
	
	var min=0;
	var max=0;
	var str="";
	var j=0;
	
	$(".kr-select").each(function(index,ele){
		var obj=$(ele);
		if(!obj.hasClass("head-type") )
		{
			obj.children("option").each(function(index2,ele2){
			 
			if(index2)
			{
				if(i==1)
				{
					//----切换为kg/cm
					min=Math.round($(ele2).attr("min"));
					max=Math.round($(ele2).attr("max"));
					str=obj.data("dw");
					if(obj.data("dw")=='lb')
					{
						str="kg";
						
					}else if(obj.data("dw")=='inch')
					{
						str="cm";
					}
				
					$(ele2).text(min+'-'+max+str);
					obj.prev("span").find("font").text(str);
				
				}
				else{
					//--切换为lb inch
					str=$(ele2).attr("value")+obj.data("dw");
					$(ele2).text(str);
					obj.prev("span").find("font").text(obj.data("dw"));
					
					
					
					
				}
			}
			
			
		});
		}
		
		
		
	});
}

$(".input-unit").change(function(){
	var i=$(this).val();
	change_togm(i);
	
	
});




//---------------筛选

$(".t-xs").focus(function(){
	var i=$(this).val();
	if(i==0)
	{
		$(this).val('');
	}

});

$(".t-xs").blur(function(){
	var i=$(this).val();
	if(!i)
	{
		$(this).val(0.0);
	}

});





$("#v-select").click(function(){
	
	$(".wap-tool>.faiter").removeClass("show-cur");
	//价格
    $(".srb-box,.wap-tool-close").removeClass("open");//关闭手机端 筛选
	
	$(".sr-s-box").addClass("loading");
	var min_price=$(".min-price").val()*1.0;
	var max_price=$(".max-price").val()*1.0;
	
	var min_weight=$(".weight option:selected").attr("min")*1.0;
	var max_weight=$(".weight option:selected").attr("max")*1.0;
	
	var min_h=$(".max-height option:selected").attr("min")*1.0;
	var max_h=$(".max-height option:selected").attr("max")*1.0;
	
	var min_h_min=$(".min-height option:selected").attr("min")*1.0;
	var max_h_min=$(".min-height option:selected").attr("max")*1.0;
	
	var min_load=$(".max-load option:selected").attr("min")*1.0;
	var max_load=$(".max-load option:selected").attr("max")*1.0;
	
	var h_type=$(".head-type").val();
	
	
	var data=new Array();
	var s_reg=/,/;
	$(".a-item").each(function(index,ele){
		
		data[index]={id:$(ele).attr("id"),head:$(ele).data("head"),weight:$(ele).data("weight"),min_price:$(ele).data("min-price"),max_price:$(ele).data("max-price"),max_h:$(ele).data("max-h"),min_h:$(ele).data("min-h"),max_load:$(ele).data("max-load")};
		
		if(s_reg.test(data[index]['min_price']))
		{
			data[index]['min_price']=data[index]['min_price'].replace(/,/,'');
		}
		
		if(s_reg.test(data[index]['max_price']))
		{
			data[index]['max_price']=data[index]['max_price'].replace(/,/,'');
		}
	
	});
	
	var i=0;
	$(".none-data-box").text("");
	$(".sr-bh-list .a-item").removeClass("a-none");
	
	for(i=0;i<data.length;i++)
	{
		
		if(h_type)
		{
			if(h_type!=data[i]['head'] || !data[i]['head'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
		}
		
		
		if(min_price>=0 && max_price>=0)
		{
			if(min_price>0)
			{
				if(data[i]['max_price']<min_price || !data[i]['max_price'])
				{
					
					$("#"+data[i]['id']).addClass("a-none");
					continue;
				}
				
			}
		
			if(max_price>0)
			{
				if(data[i]['min_price']>max_price || !data[i]['min_price'])
				{
					$("#"+data[i]['id']).addClass("a-none");
					continue;
				}
				
			}
		}
		
		//重
		if(min_weight>0)
		{
			if(data[i]['weight']<min_weight || !data[i]['weight'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
		
		}
		
		if(max_weight>0)
		{
			
			if(data[i]['weight']>max_weight || !data[i]['weight'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
		
		}
		
		//最大高度
		if(min_h>0)
		{
			
			if(data[i]['max_h']<min_h || !data[i]['max_h'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
		
		
		}
		
		if(max_h>0)
		{
			
			if(data[i]['max_h']>max_h || !data[i]['max_h'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
			
		}
		
		//-------------------最小高度
		if(min_h_min>0)
		{
			
			if(data[i]['min_h']<min_h_min || !data[i]['min_h'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
			
		
		}
		
		
		if(i==1)
		{
			//alert(max_h_min+','+data[i]['min_h']);
		}
		
		if(max_h_min>0)
		{
			if(data[i]['min_h']>max_h_min || !data[i]['min_h'])
			{
					
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
			
		}
		
		//承重
		if(min_load>0)
		{
			if(data[i]['max_load']<min_load || !data[i]['max_load'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
			
		}
		
		//
		if(max_load>0)
		{
			
			if(data[i]['max_load']>max_load || !data[i]['max_load'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
			
		}
		
		
	}
	
	 
	
	
	
	if($(".a-item").length == $(".a-none").length)
	{
		$(".sr-s-box").removeClass("loading").addClass("none-data");
		$(".none-data-box").text("Not Found !");
		
	}else{
        
		 

        window.setTimeout(function(){
          $(".sr-s-box").removeClass("loading").removeClass("none-data");
        },1000);
		
	}
	
});











